import React from "react";
import { Link } from "react-router-dom";


const BlogCard = ({ post }) => {
  const formattedDate = new Date(post.date).toLocaleDateString("en-IN", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

  // Ensure 2-line height space even for short descriptions
  const getTwoLineDescription = (text = "") => {
    if (!text) return "\u00A0\n\u00A0"; // two non-breaking spaces
    return text;
  };

  return (
    <Link
      to={`/blog/${post.BlogID}`}
      key={post.BlogID}
      className="overflow-hidden block"
    >
      <img
        src={`https://cyclecircle.blr1.cdn.digitaloceanspaces.com/${process.env.REACT_APP_IMAGE_BASE}_BLOGS_IMAGE/${
          post.Image || ""
        }`}
        alt={post.Title}
        className="w-full h-48 object-cover rounded-lg"
      />
      <div className="mt-2">
        <div className="text-sm text-gray-500">
          {formattedDate} &nbsp;•&nbsp; By {post.author}
        </div>

        {/* One-line clamped title */}
        <h2 className="font-bold text-lg text-black-1 truncate">{post.Title}</h2>

        {/* Always two-line description */}
        <p className="text-gray-600 text-sm line-clamp-2 min-h-[40px]">
          {getTwoLineDescription(post.Description)}
        </p>

        <div className="mt-2 flex items-center gap-2 flex-wrap">
          <span className="bg-[#e3e3e3] rounded-sm px-2 py-1 text-black-1 text-[12px]">
            {post.CategoryName}
          </span>
          <span className="bg-[#e3e3e3] rounded-sm px-2 py-1 text-black-1 text-[12px]">
            {post.ManufactureName}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;
